/**
 * 画面リロード
 */
export const reloadWindow = (): void => {
  window.location.reload();
};
